import axios from "axios";
import { config } from "../config";
import { languagesBank } from "../../components/languages";


let translations = {
    "ar": null,
    "en": null,
    "et-ee": null,
    "he": null,
    "jp-jp": null,
    "kk-kz": null,
    "pl-pl": null,
    "ru-kz": null,
    "uk-ua": null,
    "xc-pl": null
}

let holmTranslationsLoading = false;

export default class TranslationService {
    static getLanguage(user) {
        let language = navigator.language.toLowerCase().replace('_', '-');

        if (Object.keys(translations).indexOf(language) === -1 || user === null) {
            language = this.getDefaultLanguage();
        }

        if (user !== null && Object.keys(translations).indexOf(user.language) >= 0) {
            language = user.language;
        }

        let settings = localStorage.getItem('language');
        if (settings !== null && Object.keys(translations).indexOf(settings) >= 0) {
            language = settings;
        }

        return language;
    }

    static getTextDirection(user) {
        return translations[this.getLanguage(user)] === null ? 'ltr' : translations[this.getLanguage(user)]._direction;
    }

    static getDefaultLanguage() {
        return 'pl-pl';
    }

    static getMonthsList(lang)
    {
        return [
            {id: 1, name: this.trans(lang, 'common.months.1')},
            {id: 2, name: this.trans(lang, 'common.months.2')},
            {id: 3, name: this.trans(lang, 'common.months.3')},
            {id: 4, name: this.trans(lang, 'common.months.4')},
            {id: 5, name: this.trans(lang, 'common.months.5')},
            {id: 6, name: this.trans(lang, 'common.months.6')},
            {id: 7, name: this.trans(lang, 'common.months.7')},
            {id: 8, name: this.trans(lang, 'common.months.8')},
            {id: 9, name: this.trans(lang, 'common.months.9')},
            {id: 10, name: this.trans(lang, 'common.months.10')},
            {id: 11, name: this.trans(lang, 'common.months.11')},
            {id: 12, name: this.trans(lang, 'common.months.12')}
        ];
    }

    static trans(lang, key, params = {}) {
        this.loadHolmTranslations(lang);

        if (Object.keys(translations).indexOf(lang) === -1) {
            lang = this.getDefaultLanguage();
        }

        if (translations[lang] === null || Object.keys(translations[lang]).indexOf(key) === -1) {
            return key;
        }

        let text = translations[lang][key];

        if (params !== undefined && params !== null && typeof params === 'object') {
            Object.keys(params).forEach(key => {
                text = text.replaceAll(key, params[key]);
            });
        }

        return text;
    }

    static get12HoursHour(date) {
        let hours = date.getHours() % 12;
        hours = hours ? hours : 12;

        return hours < 10 ? '0' + hours : hours;
    }

    static get12HoursAMPM(date) {
        return date.getHours() >= 12 ? 'pm' : 'am';
    }

    static transNumbers(lang, text) {
        if (typeof text === 'undefined' || text === null || text === '') {
            return '';
        }

        if (lang !== 'ar' || translations[lang] === null) {
            return text;
        }

        return text.toString().replaceAll('0', this.trans(lang, 'common.numbers.0'))
            .replaceAll('1', this.trans(lang, 'common.numbers.1'))
            .replaceAll('2', this.trans(lang, 'common.numbers.2'))
            .replaceAll('3', this.trans(lang, 'common.numbers.3'))
            .replaceAll('4', this.trans(lang, 'common.numbers.4'))
            .replaceAll('5', this.trans(lang, 'common.numbers.5'))
            .replaceAll('6', this.trans(lang, 'common.numbers.6'))
            .replaceAll('7', this.trans(lang, 'common.numbers.7'))
            .replaceAll('8', this.trans(lang, 'common.numbers.8'))
            .replaceAll('9', this.trans(lang, 'common.numbers.9'))
            .replaceAll('.', this.trans(lang, 'common.numbers.decimal_separator'));
    }

    static untransNumbers(lang, text) {
        if (typeof text === 'undefined' || text === null || text === '') {
            return '';
        }

        if (lang !== 'ar' || translations[lang] === null) {
            return text;
        }

        return text.toString().replaceAll(this.trans(lang, 'common.numbers.0'), '0')
            .replaceAll(this.trans(lang, 'common.numbers.1'), '1')
            .replaceAll(this.trans(lang, 'common.numbers.2'), '2')
            .replaceAll(this.trans(lang, 'common.numbers.3'), '3')
            .replaceAll(this.trans(lang, 'common.numbers.4'), '4')
            .replaceAll(this.trans(lang, 'common.numbers.5'), '5')
            .replaceAll(this.trans(lang, 'common.numbers.6'), '6')
            .replaceAll(this.trans(lang, 'common.numbers.7'), '7')
            .replaceAll(this.trans(lang, 'common.numbers.8'), '8')
            .replaceAll(this.trans(lang, 'common.numbers.9'), '9')
            .replaceAll(this.trans(lang, 'common.numbers.decimal_separator'), '.');
    }

    static loadHolmTranslations(lang, preCallback = null, postCallback = null) {
        if (holmTranslationsLoading) {
            return;
        }

        if (translations[lang] !== null) {
            if (postCallback !== null && typeof postCallback === "function") {
                postCallback(lang);
            }
            return;
        }

        if (preCallback !== null && typeof preCallback === "function") {
            preCallback(lang);
        }

        holmTranslationsLoading = true;

        axios.get(config.apiAddress + '/settings/translations?lang=' + lang)
            .then(function (response) {
                holmTranslationsLoading = false;
                translations[lang] = response.data;
                languagesBank.enableLanguage(lang);

                if (postCallback !== null && typeof postCallback === "function") {
                    postCallback(lang);
                }

                const name = TranslationService.trans(lang, '_name');

                if (name !== 'Andra') {
                    document.title = name;
                }
            }).catch(function(response) {
                console.error('Translations loading error')
            });
    }
}
